import React from "react";
import { MapPin, Twitter, Instagram, Github, Mail } from "lucide-react";
import StoreBadges from "./StoreBadges";

const Footer = ({ onTrackDownload }) => {
  return (
    <footer className="bg-emerald-950 text-white pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-5 gap-10 pb-14 border-b border-white/10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-800 grid place-items-center">
                <MapPin className="w-5 h-5 text-emerald-50" />
              </div>
              <span className="font-display text-2xl font-semibold">Splitara</span>
            </div>
            <p className="text-white/70 max-w-sm">
              Group travel planning, shared expenses, maps, messaging, and memories — in one thoughtfully designed app.
            </p>
            <p className="text-white/50 text-xs mt-3">Operated by TECH HUB CITY PROPRIETARY LIMITED.</p>

            <div className="mt-8">
              <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-3">Download the app</div>
              <StoreBadges size="sm" theme="dark" onClickTrack={onTrackDownload} />
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">App</div>
            <ul className="space-y-2 text-white/80">
              <li><a href="#get-app" className="hover:text-white">Create account</a></li>
              <li><a href="#get-app" className="hover:text-white">Log in</a></li>
              <li><a href="#features" className="hover:text-white">Features</a></li>
              <li><a href="#reviews" className="hover:text-white">Reviews</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Legal</div>
            <ul className="space-y-2 text-white/80">
              <li><a href="#" className="hover:text-white">Terms</a></li>
              <li><a href="#" className="hover:text-white">Privacy</a></li>
              <li><a href="#" className="hover:text-white">Cookies</a></li>
              <li><a href="/account-deletion" className="hover:text-white">Data deletion</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Contact</div>
            <ul className="space-y-2 text-white/80 text-sm">
              <li><a href="mailto:support@splitara.app" className="hover:text-white flex items-center gap-2"><Mail className="w-3.5 h-3.5" /> support@splitara.app</a></li>
              <li><a href="mailto:privacy@splitara.app" className="hover:text-white flex items-center gap-2"><Mail className="w-3.5 h-3.5" /> privacy@splitara.app</a></li>
              <li><a href="mailto:legal@splitara.app" className="hover:text-white flex items-center gap-2"><Mail className="w-3.5 h-3.5" /> legal@splitara.app</a></li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 grid place-items-center hover:bg-white/10"><Twitter className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 grid place-items-center hover:bg-white/10"><Instagram className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 grid place-items-center hover:bg-white/10"><Github className="w-4 h-4" /></a>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-white/50 text-sm">© {new Date().getFullYear()} Splitara. Made for travellers, by travellers.</div>
          <div className="text-white/50 text-sm">Manage · <a href="#" className="hover:text-white">Cookie preferences</a></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
